import { __rest } from 'tslib';
import React from 'react';
import { useTheme } from '../../theme/Theme.js';
import { Hidden, SpinnerContainer, Spinner, Root } from './styled.js';

const BaseButton = (_a, ref) => {
    var { padding = true, loading = false, disabled = false, danger = false, skeleton = false, fullWidth = false, variant = 'primary', size = 'medium', preset = 'default', before, after, children, onClick } = _a, props = __rest(_a, ["padding", "loading", "disabled", "danger", "skeleton", "fullWidth", "variant", "size", "preset", "before", "after", "children", "onClick"]);
    const theme = useTheme();
    const hasChildren = !!children;
    const hasLeftIcon = !!before;
    const hasRightIcon = !!after;
    const hasBothIcons = hasLeftIcon && hasRightIcon;
    const hasOnlyLeftIcon = hasLeftIcon && !hasChildren;
    const hasOnlyRightIcon = hasRightIcon && !hasChildren;
    const isIconOnly = hasOnlyLeftIcon || hasOnlyRightIcon;
    const as = props.as || 'button';
    const shape = (() => {
        if (padding === false)
            return 'noPadding';
        if (isIconOnly)
            return 'iconOnly';
        if (hasBothIcons)
            return 'default';
        if (hasLeftIcon)
            return 'iconLeft';
        if (hasRightIcon)
            return 'iconRight';
        return 'default';
    })();
    const content = React.useMemo(() => {
        if (skeleton)
            return (React.createElement(Hidden, null,
                before,
                children,
                after));
        if (loading)
            return (React.createElement(SpinnerContainer, null,
                React.createElement(Spinner, { size: 'xs' }),
                React.createElement(Hidden, null,
                    before,
                    children,
                    after)));
        return (React.createElement(React.Fragment, null,
            before,
            children,
            after));
    }, [skeleton, before, children, after, loading]);
    const handleClick = React.useCallback((e) => {
        if (loading || disabled) {
            e.preventDefault();
            return;
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    }, [disabled, loading, onClick]);
    return (React.createElement(Root, Object.assign({ "data-testid": 'tend-ui-button' }, props, { ref: ref, theme: theme, "$skeleton": skeleton, "$danger": danger, "$disabled": disabled, "$variant": variant, "$size": size, "$preset": preset, "$tag": as, "$fullWidth": fullWidth, "$shape": shape, as: as, disabled: disabled, onClick: handleClick }), content));
};
const Button = React.forwardRef(BaseButton);
Button.displayName = 'Button';

export { Button };
//# sourceMappingURL=Button.js.map
